import { Flex } from '@radix-ui/themes';

import { DataCardLayout } from './DataCardLayout';
import styles from './Metrics.module.css';

export interface DataCardProps {
    title: string;
    content: string | number;
    subTitle?: string;
}

export const DataCard = (props: DataCardProps) => (
    <Flex
        className={styles.dataCard}
        direction={'column'}
        align={'start'}
        justify={'center'}
        width={'100%'}
    >
        <DataCardLayout {...props} />
    </Flex>
);
